// Libraries
import clsx from "clsx";
import { Stack, Button, CircularProgress, Box } from "@mui/material";

type THeaderSectionProps = {
	disabled: {
		discardButton: boolean;
		applyButton: boolean;
	};
	isSaving: boolean;
	handleDiscardChanges: () => void;
	handleApplyMapping: () => void;
};

export default function HeaderSection(props: Readonly<THeaderSectionProps>) {
	const { disabled, isSaving, handleApplyMapping, handleDiscardChanges } = props;
	const { applyButton, discardButton } = disabled;

	return (
		<Box
			component={"form"}
			sx={{
				position: "absolute",
				right: "50px",
			}}
		>
			{/* Action Buttons */}
			<Stack direction={"row"} spacing={4}>
				<Button
					variant="contained"
					className={clsx({
						"!rounded-md !h-[30px] w-[125px] !font-normal !normal-case !font-sans text-[14px] !shadow-none": true,
						"!bg-gray-blue hover:!shadow-gray-blue-shadow-50": !discardButton,
						"!bg-disabled !text-white": discardButton,
					})}
					onClick={handleDiscardChanges}
					disabled={discardButton}
				>
					Discard Changes
				</Button>
				<Button
					variant="contained"
					className={clsx({
						"!rounded-md !h-[30px] w-[125px] !font-normal !normal-case !font-sans !text-[14px] !shadow-none": true,
						"!bg-primary hover:!shadow-primary-shadow-50": !applyButton,
						"!bg-disabled !text-white": applyButton,
					})}
					onClick={handleApplyMapping}
					disabled={applyButton}
				>
					{isSaving ? <CircularProgress sx={{ color: "white", marginX: "28px" }} size={20} /> : "Apply Mapping"}
				</Button>
			</Stack>
		</Box>
	);
}
